import { render, staticRenderFns } from "./totalRevenueData.vue?vue&type=template&id=6ece5e6d&scoped=true&"
import script from "./totalRevenueData.vue?vue&type=script&lang=js&"
export * from "./totalRevenueData.vue?vue&type=script&lang=js&"
import style0 from "./totalRevenueData.vue?vue&type=style&index=0&id=6ece5e6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece5e6d",
  null
  
)

export default component.exports